webpackJsonp([53],{

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1091);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("bf5dffa6", content, true);

/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.center-buttons[data-v-93737144]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/opt/buildhome/repo/src/pages/configuration/page-master-companies.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,iCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC","file":"page-master-companies.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.center-buttons[data-v-93737144] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1092:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_master_companies_vue__ = __webpack_require__(862);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a326db4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_master_companies_vue__ = __webpack_require__(1093);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_master_companies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a326db4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_master_companies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1093:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-1"},[_c('app-table',{staticClass:"mt-3 is-not-selectable px-4",attrs:{"name":"master-companies-list","selected-value":_vm.selectedValue,"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.rows,"current-page":_vm.currentPage,"last-page":_vm.lastPage,"selectable":""},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.nombreComercial)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.razonSocial)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.ruc)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.codeCompany)+"\n\t\t\t")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1094:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-companies"},[_c('action-sidebar',{attrs:{"title":"Proyectos","value":true,"width":500},on:{"close-modal":_vm.closeModal}},[_c('v-tabs',{attrs:{"right":"","slider-color":"cyan"},model:{value:(_vm.tabsModel),callback:function ($$v) {_vm.tabsModel=$$v},expression:"tabsModel"}},[_vm._l((_vm.tabs),function(item,index){return _c('v-tab',{key:index},[_vm._v("\n\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t")])}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',[_c('table-master-companies',{attrs:{"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.companies,"selected-value":_vm.selectedValue,"last-page":_vm.lastPageAssigned,"current-page":_vm.currentPageAssigned},on:{"all-is-selected":_vm.allIsSelected,"on-search":_vm.onSearchList,"row-is-selected":_vm.rowIsSelected,"change-page":_vm.changePageAssigned}})],1),_vm._v(" "),_c('v-tab-item',[_c('table-master-companies',{attrs:{"check-all":_vm.checkAllDeallocated,"columns":_vm.columns,"rows":_vm.companiesListAssigned,"last-page":_vm.lastPage,"current-page":_vm.currentPage,"selected-value":_vm.selectedValueDeallocated},on:{"change-page":_vm.changePage,"on-search":_vm.onSearchDeallocated,"all-is-selected":_vm.allIsSelectedDeallocated,"row-is-selected":_vm.rowIsSelectedDeallocated}})],1)],1)],2),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer pt-4 pb-4 center-buttons"},[_c('v-btn',{staticClass:"btn-action caption ml-2",attrs:{"color":"pink"},on:{"click":_vm.closeModal}},[_vm._v("\n\t\t\t\t\tCancelar\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-1",attrs:{"color":"success","disabled":_vm.disabledProject(1)},on:{"click":_vm.assignRow}},[_vm._v("\n\t\t\t\t\tAsignar\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-2",attrs:{"color":"success","disabled":_vm.disabledDeallocated(0)},on:{"click":_vm.deallocateButton}},[_vm._v("\n\t\t\t\t\tDesasignar\n\t\t\t\t")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_master_companies_vue__ = __webpack_require__(861);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93737144_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_master_companies_vue__ = __webpack_require__(1094);
function injectStyle (ssrContext) {
  __webpack_require__(1090)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93737144"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_master_companies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93737144_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_master_companies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_configuration_table_master_companies__ = __webpack_require__(1092);




var deallocateButton = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var companiesIds, body, url;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						companiesIds = this.dataSelectedDeallocated.map(function (item) {
							return item.id;
						});
						body = { companiesIds: companiesIds };
						url = 'distributaries/' + this.id + '/company-parent';
						_context.prev = 3;
						_context.next = 6;
						return this.$http.delete(url, { data: body });

					case 6:
						this.companiesListDeallocated();
						this.closeModal();
						this.showNotification('Fueron desasignados correctamente');
						_context.next = 14;
						break;

					case 11:
						_context.prev = 11;
						_context.t0 = _context['catch'](3);

						this.showError();

					case 14:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 11]]);
	}));

	return function deallocateButton() {
		return _ref.apply(this, arguments);
	};
}();

var assignRow = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var companiesIds, url;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						companiesIds = this.dataSelected.map(function (action) {
							return action.id;
						});
						url = 'distributaries/' + this.id + '/company-parent';
						_context2.prev = 2;
						_context2.next = 5;
						return this.$http.post(url, { companiesIds: companiesIds });

					case 5:
						this.companiesList();
						this.closeModal();
						this.showNotification('Los proyectos fueron asignados correctamente');
						_context2.next = 13;
						break;

					case 10:
						_context2.prev = 10;
						_context2.t0 = _context2['catch'](2);

						this.showError();

					case 13:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[2, 10]]);
	}));

	return function assignRow() {
		return _ref2.apply(this, arguments);
	};
}();

var companiesList = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var params, url, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.search,
							perPage: 30,
							isSelected: 0
						};
						url = '/projects/' + this.codeProject + '/distributaries/' + this.id + '/company-parent';
						_context3.prev = 2;
						_context3.next = 5;
						return this.$http.get(url, { params: params });

					case 5:
						response = _context3.sent;

						this.companies = response.data.data;
						this.lastPageAssigned = Number(response.headers['x-last-page']);
						_context3.next = 13;
						break;

					case 10:
						_context3.prev = 10;
						_context3.t0 = _context3['catch'](2);

						this.showError();

					case 13:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[2, 10]]);
	}));

	return function companiesList() {
		return _ref3.apply(this, arguments);
	};
}();

var companiesListDeallocated = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var params, url, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.search,
							perPage: 30,
							isSelected: 1
						};
						url = '/projects/' + this.codeProject + '/distributaries/' + this.id + '/company-parent';
						_context4.prev = 2;
						_context4.next = 5;
						return this.$http.get(url, { params: params });

					case 5:
						response = _context4.sent;

						this.companiesListAssigned = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context4.next = 13;
						break;

					case 10:
						_context4.prev = 10;
						_context4.t0 = _context4['catch'](2);

						this.showError();

					case 13:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[2, 10]]);
	}));

	return function companiesListDeallocated() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.companiesList();
	this.companiesListDeallocated();
}

function changePageAssigned(page) {
	this.params.page = page;
	this.currentPageAssigned = page;
	this.companiesList();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.companiesListDeallocated();
}

function closeModal() {
	this.goTo('page-dealers-projects');
}

function disabledDeallocated(value) {
	return this.tabsModel === value || this.dataSelectedDeallocated < 1;
}

function disabledProject(value) {
	return this.tabsModel === value || this.dataSelected.length < 1;
}

function onSearchList(value) {
	this.params.search = value ? value.trim() : null;
	this.companiesList();
}

function onSearchDeallocated(search) {
	this.params.search = search ? search.trim() : null;
	this.companiesListDeallocated();
}

function allIsSelectedDeallocated(checked) {
	var _this = this;

	this.checkAllDeallocated = checked;
	this.dataSelectedDeallocated = [];
	this.companiesListAssigned = this.companiesListAssigned.map(function (item) {
		var newRowDeallocated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
		newRowDeallocated.isSelected = checked;
		if (checked) {
			_this.dataSelectedDeallocated.push(item);
		}
		return newRowDeallocated;
	});
	this.companiesListAssigned = this.selectIsRow(this.companiesListAssigned, this.selectedValueDeallocated, false, checked);
}

function allIsSelected(checked) {
	var _this2 = this;

	this.checkAll = checked;
	this.dataSelected = [];
	this.companies = this.companies.map(function (element) {
		var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element);
		newRow.isSelected = checked;
		if (checked) {
			_this2.dataSelected.push(element);
		}
		return newRow;
	});
	this.companies = this.selectIsRow(this.companies, this.selectedValue, false, checked);
}

function rowIsSelected(row) {
	this.companies = this.selectIsRow(this.companies, this.selectedValue, row);
	this.checkAll = this.every(this.companies, this.selectedValue);
	this.dataSelected = this.companies.filter(function (r) {
		return r.flagSelected;
	});
}

function rowIsSelectedDeallocated(row) {
	this.companiesListAssigned = this.selectIsRow(this.companiesListAssigned, this.selectedValueDeallocated, row);
	this.checkAll = this.every(this.companiesListAssigned, this.selectedValueDeallocated);
	this.dataSelectedDeallocated = this.companiesListAssigned.filter(function (r) {
		return r.flag;
	});
}

function data() {
	return {
		actionParams: {
			codeProject: '',
			resourceId: 0
		},
		checkAll: false,
		checkAllDeallocated: false,
		columns: [{ id: 1, name: 'Nombre', value: 'nombreComercial', checked: true, visible: true }, { id: 2, name: 'Razón social', value: 'razonSocial', checked: true, visible: true }, { id: 3, name: 'RUC', value: 'ruc', checked: true, visible: true }, { id: 4, name: 'Código', value: 'codeCompany', checked: true, visible: true }],
		currentPage: 1,
		currentPageAssigned: 1,
		dataSelected: [],
		dataSelectedDeallocated: [],
		lastPage: 0,
		lastPageAssigned: 0,
		rowAssigned: [],
		params: {
			page: 1
		},
		companiesListAssigned: [],
		projectId: null,
		companies: [],
		tabs: [{
			id: 1,
			name: 'Asignar'
		}, {
			id: 2,
			name: 'Asignados'
		}],
		tabsModel: null,
		selectedValue: 'flagSelected',
		selectedValueDeallocated: 'flag'
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-projects',
	created: created,
	data: data,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__["default"],
		tableMasterCompanies: __WEBPACK_IMPORTED_MODULE_4__components_configuration_table_master_companies__["a" /* default */]
	},
	methods: {
		rowIsSelectedDeallocated: rowIsSelectedDeallocated,
		allIsSelectedDeallocated: allIsSelectedDeallocated,
		allIsSelected: allIsSelected,
		assignRow: assignRow,
		changePage: changePage,
		changePageAssigned: changePageAssigned,
		closeModal: closeModal,
		deallocateButton: deallocateButton,
		disabledDeallocated: disabledDeallocated,
		disabledProject: disabledProject,
		companiesList: companiesList,
		companiesListDeallocated: companiesListDeallocated,
		rowIsSelected: rowIsSelected,
		onSearchList: onSearchList,
		onSearchDeallocated: onSearchDeallocated
	},
	props: {
		codeProject: {
			type: [Number, String]
		},
		id: {
			type: Number,
			required: true
		}
	}
});

/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function onSearch(value) {
	this.$emit('on-search', value);
}

function changePage(page) {
	this.$emit('change-page', page);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function allIsSelected(row) {
	this.$emit('all-is-selected', row);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'dealers-list',
	methods: {
		allIsSelected: allIsSelected,
		changePage: changePage,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	},
	props: {
		rows: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		lastPage: {
			type: Number,
			default: 0
		},
		currentPage: {
			type: Number,
			default: 0
		},
		columns: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		checkAll: {
			type: Boolean,
			required: true
		},
		selectedValue: {
			type: String,
			required: true
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/53.76d37c41787c9f686d9f.js